import axios from "axios";
import { timeConverter } from "../../utils/timeUtil";

export const getProductInfo = (barcode, setProductInfo) => {
  const requestData = {
    ean: barcode,
  };

  axios
    .post("/check_barcode", requestData)
    .then((response) => {
      setProductInfo(response.data.product[0]); //TODO: check
    })
    .catch((err) => {
      console.log(
        "[getProductName.actions.js] getProductInfo || Could not obtain product name of this barcode. Try again later."
      );
    });
};

export const setProductInfo = (
  product_id,
  inventory_amount,
  packages_amount,
  location_id,
  setTogglePopup
) => {
  var currentTime = timeConverter(Date.now());

  const requestData = {
    product_id: product_id,
    quantity: inventory_amount,
    package: packages_amount,
    timestamp: currentTime,
    location: location_id,
  };

  axios
    .post("/stock_count", requestData)
    .then((response) => {
      setTogglePopup(false);
    })
    .catch((err) => {
      console.log(
        "[scanner.actions.js] setProductInfo || Could not set product information of this product. Try again later."
      );
    });
};

export default (getProductInfo, setProductInfo);
